import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

import "react-tabs/style/react-tabs.css";
import CancelledExperience from "../../Components/User/CancelledExperience";
import CompletedExperience from "../../Components/User/CompletedExperience";
import UpcomingExperiences from "../../Components/User/UpcomingExperiences";
import { fetchCmsMetaData } from "../../Components/Utility/cmsMetaService";
import { SetMetaTags } from "../../Components/Utility/setMetaTags";

function UserExperiences() {
  const [activeTab, setActiveTab] = useState(0);
    const [completedTabs, setCompletedTabs] = useState([]);
    const [upcomingCount, setUpcomingCount] = useState(0); 
    const [meta,setMeta] = useState();


  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [activeTab]); // ✅ scrolls every time tab changes

   useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("experience");
      setMeta(data);
    };

    loadMeta();
  }, []);

  return (
    <section className="user_allls ntx_tabs_links usr_experience">

       <SetMetaTags
        title= {meta?.meta_title || "Experience | Weyfarin"}
        description={meta?.meta_description || "Experience | Weyfarin"}
      
      />

	    <div className="bedcramss">
				 <Link to="/profile">
            Dashboard
          </Link>{" "}
          &gt; Experience
				</div>
        <Tabs
        //  selectedIndex={activeTab} onSelect={(index) => setActiveTab(index)}
        selectedIndex={activeTab} onSelect={(index) => setActiveTab(index)}
         >
          {/* ✅ Tab Headers */}
          <TabList>
            <Tab  className={`react-tabs__tab 
    ${activeTab === 0 ? "react-tabs__tab--selected" : ""} 
    ${completedTabs.includes(0) ? "completed" : ""}`}>
              <h5>Upcoming<span className="count">{upcomingCount}</span></h5>
              
            </Tab>
            <Tab  className={`react-tabs__tab 
    ${activeTab === 1 ? "react-tabs__tab--selected" : ""} 
    ${completedTabs.includes(1) ? "completed" : ""}`} >
              <h5>Cancelled</h5>
              
            </Tab>
            <Tab  className={`react-tabs__tab 
    ${activeTab === 2 ? "react-tabs__tab--selected" : ""} 
    ${completedTabs.includes(2) ? "completed" : ""}`} >
              <h5>Completed</h5>
              
            </Tab>
            
          </TabList>

          {/* ✅ Tab Panels */}
          <TabPanel>
            <UpcomingExperiences  onSuccess={(id) => {
            setActiveTab(1); 
          }} 
          onCountChange={(count) => setUpcomingCount(count)}/>
          </TabPanel>

          <TabPanel>
            <CancelledExperience  onSuccess={() => setActiveTab(2)} onBack={() => setActiveTab(0)} />
          </TabPanel>

          <TabPanel>
            <CompletedExperience  onSuccess={() => {
                console.warn("🎉 Flow Completed!");
              }} onBack={() => setActiveTab(1)} />
          </TabPanel>
        </Tabs>
    </section>
  );
}

export default UserExperiences;
